import type { AssignmentActivityDetails } from '@paintscout/api'
import React from 'react'
import Highlight from '../../Highlight'
import type { ActivityTypeComponentProps } from '../Activity'
import ActivityFooter from '../ActivityFooter'
import ActivityTitle from '../ActivityTitle'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'
import QuoteLabel from '../QuoteLabel'
import ActivityOwner from '../ActivityOwner'
import ActivityContent from '../ActivityContent'
import Typography from '../../Typography'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  message: {
    color: theme.palette.text.secondary,
    whiteSpace: 'pre-wrap'
  }
}))

export default function QuoteAssignmentActivity(props: ActivityTypeComponentProps<AssignmentActivityDetails>) {
  const classes = useStyles(props)
  const { activity, showDocTypeDetails } = props
  const message = activity.details.events?.[0]
  return (
    <>
      <ActivityTitle>
        {showDocTypeDetails ? (
          <>
            <QuoteLabel activity={activity} /> was <Highlight>Shared</Highlight>
          </>
        ) : (
          <>
            <Highlight>Shared</Highlight>
          </>
        )}{' '}
        {showDocTypeDetails && <ActivityOwner activity={activity} />}
      </ActivityTitle>
      {!!message && (
        <ActivityContent className={classes.content}>
          <Typography variant="subtitle2" className={classes.message}>
            {message}
          </Typography>
        </ActivityContent>
      )}
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
